import AddressVerificationService from './AddressVerificationService';
import Helpers from './AddressVerificationHelpers';
import getSuggestedAddressesSelection from './getSuggestedAddressesSelection';


/** @typedef {import("./types").Address} Address */
/** @typedef {import("./types").AddressInputs} AddressInputs */
/** @typedef {import("./AddressForm").default} AddressForm */


class AddressVerificationProvider {
  /**
   * @param {AddressForm} addressForm
   * @param {Address} comparingAddress
   * @param {boolean} isAddressVerificationEnabled
   */
  constructor(addressForm, comparingAddress = null, isAddressVerificationEnabled = false) {
    this.addressForm = addressForm;
    this.comparingAddress = comparingAddress;
    this.isAddressVerificationEnabled = isAddressVerificationEnabled;
  }

  testCanVerifyAddress() {
    if (!this.isAddressVerificationEnabled) {
      return false;
    }

    if (this.addressForm.getEmptyRequiredFormInputs().length) {
      return false;
    }

    const address = this.addressForm.getAddress();

    if (!Helpers.shouldVerifyAddress(address)) {
      return false;
    }

    if (Helpers.testAddressEquality(address, this.comparingAddress)) {
      return false;
    }

    return true;
  }

  async verifyAddress() {
    const userEnteredAddress = this.addressForm.getAddress();

    const suggestedAddresses = await AddressVerificationService.getSuggestedAddresses(userEnteredAddress);

    if (suggestedAddresses.length === 0) {
      return null;
    }

    return getSuggestedAddressesSelection(suggestedAddresses, userEnteredAddress);
  }
}

export default AddressVerificationProvider;



// WEBPACK FOOTER //
// ./src/addressVerification/AddressVerificationProvider.js